import RubriqueSelect from '@/generated/controls/rubrique/RubriqueSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: RubriqueSelect
})
